import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import police_logo from '../assets/images/icp/police_logo.png'
import config from '../config/config';
import { handleDownload } from '../utils/download';
const Footer = () => {
    const privacyUrl = config.privacyPolicyUrl;
    const userInfoUrl = config.userInfoUrl
    return (
        <footer className="bg-gradient-to-br from-gray-900 to-blue-900 text-white">
            <div className="container mx-auto px-4 py-12">
                {/* 主要内容区域 - 四列布局 */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">

                    {/* 快速导航 */}
                    <div>
                        <h4 className="text-lg font-bold mb-6 pb-2 border-b border-blue-700">快速导航</h4>
                        <ul className="space-y-3">
                            <li>
                                <Link to="/about" className="text-gray-300 hover:text-white transition-colors duration-300 flex items-center group">
                                    <div className="w-2 h-2 bg-blue-500 rounded-full mr-3 group-hover:scale-125 transition-transform duration-300"></div>
                                    关于我们
                                </Link>
                            </li>
                            <li>
                                <Link to="/app" className="text-gray-300 hover:text-white transition-colors duration-300 flex items-center group">
                                    <div className="w-2 h-2 bg-blue-500 rounded-full mr-3 group-hover:scale-125 transition-transform duration-300"></div>
                                    族语APP
                                </Link>
                            </li>
                            <li>
                                <Link to="/news" className="text-gray-300 hover:text-white transition-colors duration-300 flex items-center group">
                                    <div className="w-2 h-2 bg-blue-500 rounded-full mr-3 group-hover:scale-125 transition-transform duration-300"></div>
                                    新闻动态
                                </Link>
                            </li>
                            <li>
                                <HashLink to="/#contact" className="text-gray-300 hover:text-white transition-colors duration-300 flex items-center group">
                                    <div className="w-2 h-2 bg-blue-500 rounded-full mr-3 group-hover:scale-125 transition-transform duration-300"></div>
                                    联系我们
                                </HashLink>
                            </li>
                        </ul>
                    </div>

                    {/* 产品相关 */}
                    <div>
                        <h4 className="text-lg font-bold mb-6 pb-2 border-b border-blue-700">产品相关</h4>
                        <ul className="space-y-3">
                            <li>
                                <HashLink to="/#services" className="text-gray-300 hover:text-white transition-colors duration-300 flex items-center group">
                                    <div className="w-2 h-2 bg-green-500 rounded-full mr-3 group-hover:scale-125 transition-transform duration-300"></div>
                                    产品功能
                                </HashLink>
                            </li>
                            <li>
                                <HashLink to="/#portfolio" className="text-gray-300 hover:text-white transition-colors duration-300 flex items-center group">
                                    <div className="w-2 h-2 bg-green-500 rounded-full mr-3 group-hover:scale-125 transition-transform duration-300"></div>
                                    产品故事
                                </HashLink>
                            </li>
                            <li>
                                <HashLink to="/#team" className="text-gray-300 hover:text-white transition-colors duration-300 flex items-center group">
                                    <div className="w-2 h-2 bg-green-500 rounded-full mr-3 group-hover:scale-125 transition-transform duration-300"></div>
                                    开发实力
                                </HashLink>
                            </li>
                            <li>
                                <a href={privacyUrl} className="text-gray-300 hover:text-white transition-colors duration-300 flex items-center group">
                                    <div className="w-2 h-2 bg-green-500 rounded-full mr-3 group-hover:scale-125 transition-transform duration-300"></div>
                                    隐私协议
                                </a>
                            </li>
                            <li>
                                <a href={userInfoUrl} className="text-gray-300 hover:text-white transition-colors duration-300 flex items-center group">
                                    <div className="w-2 h-2 bg-green-500 rounded-full mr-3 group-hover:scale-125 transition-transform duration-300"></div>
                                    用户协议
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* 联系我们 */}
                    <div>
                        <h4 className="text-lg font-bold mb-6 pb-2 border-b border-blue-700">联系我们</h4>
                        <div className="space-y-4">
                            {/* 地址信息 */}
                            <div className="flex items-start group">
                                <div className="w-5 h-5 text-blue-400 mt-1 mr-3 flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                    </svg>
                                </div>
                                <p className="text-gray-300 group-hover:text-white transition-colors duration-300 leading-relaxed">
                                    江西省南昌市红谷滩区红谷中大道998号绿地中央广场A1#办公楼5206-2室
                                </p>
                            </div>

                            {/* 电话信息 */}
                            <div className="flex items-center group">
                                <div className="w-5 h-5 text-blue-400 mr-3 flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                    </svg>
                                </div>
                                <a href="tel:4001818105" className="text-gray-300 hover:text-white transition-colors duration-300">
                                    4001818105
                                </a>
                            </div>

                            {/* 邮箱信息 */}
                            <div className="flex items-center group">
                                <div className="w-5 h-5 text-blue-400 mr-3 flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                    </svg>
                                </div>
                                <a href="mailto:ryan@sayfamily.com" className="text-gray-300 hover:text-white transition-colors duration-300">
                                    ryan@sayfamily.com
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* 下载族语 */}
                    <div>
                        <h4 className="text-lg font-bold mb-6 pb-2 border-b border-blue-700">下载族语</h4>
                        <div className="flex flex-col items-center md:items-start space-y-3">
                            <button
                                onClick={() => handleDownload('ios')}
                                className="group flex w-full max-w-[220px] items-center gap-3 rounded-xl bg-white/10 hover:bg-white/20 border border-white/15 px-4 py-3 transition-all duration-300 hover:-translate-y-0.5"
                            >
                                <svg className="w-6 h-6 text-white flex-shrink-0" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
                                </svg>
                                <div className="text-left">
                                    <div className="text-[10px] text-gray-300 leading-none">iPhone 用户</div>
                                    <div className="text-sm font-semibold text-white leading-tight">App Store 下载</div>
                                </div>
                            </button>

                            <button
                                onClick={() => handleDownload('android')}
                                className="group flex w-full max-w-[220px] items-center gap-3 rounded-xl bg-white/10 hover:bg-white/20 border border-white/15 px-4 py-3 transition-all duration-300 hover:-translate-y-0.5"
                            >
                                <svg className="w-6 h-6 text-green-400 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M17.6 9.48l1.84-3.18c.16-.31.04-.69-.26-.85a.637.637 0 0 0-.83.22l-1.88 3.24a11.43 11.43 0 0 0-8.94 0L5.65 5.67a.643.643 0 0 0-.87-.2c-.28.18-.37.54-.22.83L6.4 9.48A10.78 10.78 0 0 0 1 18h22a10.78 10.78 0 0 0-5.4-8.52zM7 15.25a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm10 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
                                </svg>
                                <div className="text-left">
                                    <div className="text-[10px] text-gray-300 leading-none">安卓用户</div>
                                    <div className="text-sm font-semibold text-white leading-tight">应用市场下载</div>
                                </div>
                            </button>

                            <button
                                onClick={() => handleDownload('harmony')}
                                className="group flex w-full max-w-[220px] items-center gap-3 rounded-xl bg-white/10 hover:bg-white/20 border border-white/15 px-4 py-3 transition-all duration-300 hover:-translate-y-0.5"
                            >
                                <svg className="w-6 h-6 text-[#08C18A] flex-shrink-0" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                                    <circle cx="12" cy="12" r="9" />
                                </svg>
                                <div className="text-left">
                                    <div className="text-[10px] text-gray-300 leading-none">鸿蒙用户</div>
                                    <div className="text-sm font-semibold text-white leading-tight">华为应用市场</div>
                                </div>
                            </button>

                            <p className="text-gray-400 text-xs pt-1">点击按钮，一键下载族语APP</p>
                        </div>
                    </div>
                </div>

                {/* 版权信息 */}
                {/* 版权信息和备案信息 */}
                <div className="pt-8 mt-8 border-t border-gray-700">
                    <div className="flex flex-col md:flex-row justify-between items-center">
                        <div className="text-gray-400 text-sm mb-4 md:mb-0 text-center md:text-left">
                            <div className="mb-2">
                                Copyright &copy; {new Date().getFullYear()} 江西族迹信息技术有限公司. 保留所有权利.

                            </div>
                            {/* ICP备案信息 */}
                            <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start space-y-2 sm:space-y-0 sm:space-x-4">

                                <a
                                    href="https://beian.miit.gov.cn/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-400 hover:text-blue-300 transition-colors duration-300 text-sm"
                                >
                                    赣ICP备2025070070号
                                </a>
                                {/* 公安备案信息（如果有的话） */}
                                <a
                                    href="https://beian.mps.gov.cn/#/query/webSearch?code=36010802001245"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-400 hover:text-blue-300 transition-colors duration-300 text-sm flex items-center"
                                >
                                    <img
                                        src={police_logo}
                                        alt="公网安备"
                                        className="w-4 h-4 mr-1"
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                        }}
                                    />
                                    赣公网安备36010802001245号
                                </a>
                            </div>
                        </div>
                        <div className="flex space-x-6 text-sm text-gray-400">
                            <a
                                href={privacyUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="hover:text-white transition-colors duration-300"
                            >
                                隐私政策
                            </a>
                            <Link to="/" className="hover:text-white transition-colors duration-300">使用条款</Link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
